const translations = {
  general: {
    documentTitle: 'Search used cars',
  },
  compare: {
    back: 'Back',
    searchMore: 'Find more used cars',
    pageTitle: 'Compare used cars',
    photo: 'Photo',
    emptyState: {
      title: 'No vehicles selected',
      desc: "No vehicles have been selected (yet) to compare. Find a vehicle and click 'Compare' to add it.",
      button: 'Search used cars',
    },
  },
  vehicle: {
    mileageUnit: 'km',
    energyPowerUnit: 'kW',
    horsePowerUnit: 'hp',
    type: 'Type',
    vehicleType: 'Vehicle type',
    price: 'Price',
    year: 'Construction year',
    mileage: 'Mileage',
    fuelType: 'Fuel type',
    enginePower: 'Power',
    transmission: 'Transmission',
    license: 'License plate',
    body: 'Body',
    numberDoors: 'Number of doors',
    lining: 'Lining',
    color: 'Color',
    numberCilinders: 'Amount of cylinders',
    sizes: 'Dimensions',
    engineCapacity: 'Cylinder capacity',
    engineVolume: 'Engine capacity',
    engineCapacityUnit: 'cc',
    weight: 'Weight',
    maxTowingWeight: 'Max. pull weight',
    weightUnit: 'kg',
    volumeUnit: 'L',
    fuelConsumption: 'Consumption per {amount} km',
    taxMargin: 'VAT/Margin',
    btwMarge: 'VAT/Margin',
    energyLabel: 'Energy label',
    roadTax: 'Road tax',
    perQuarterEstimation: 'per quarter (estimate)',
    inclTax: 'incl. VAT',
    exclTax: 'excl. VAT',
    finance: {
      from: 'from',
      privateLeaseFrom: 'Private lease from',
      perMonth: 'p/month',
    },
    actions: {
      offer: 'Request quote',
      tradeIn: 'Calculate your trade-in value',
      privateLease: 'Request a private lease',
      finance: 'Apply for financing',
      testDrive: 'Request a test drive',
      callMeBack: 'Call me back',
      buy: 'Buy now',
      compare: 'Compare',
      appointment: 'Make an appointment',
      print: 'Print vehicle',
    },
    warranties: {
      napCheck: 'NAP-Check',
      hundredPercentMaintained: '100% maintained',
      carPass: 'Car-Pass',
      bovagDescription:
        'Depending on the chosen delivery package, the following warranties may be supplied with the vehicle. Contact us for information about the specific delivery packages.',
      bovag40: 'BOVAG 40 points check',
      bovagAfleverbeurt: 'BOVAG Delivery',
      bovag6months: '6 months BOVAG Warranty',
      bovag12months: '12 months BOVAG Warranty',
      bovag24months: '24 months BOVAG Warranty',
      autotrust: 'Autotrust',
      vakgarant: 'Vakgarant',
      vweOccasionPlan: 'VWE Occasion Garant Plan',
      cargarantie: 'Cargarantie',
      additionalWarrantyButton: 'View our warranty terms',
    },
  },
  loop: {
    view: 'View',
    viewCar: 'View this car',
    compare: 'Compare',
  },
  single: {
    back: 'Back to all used cars',
    contactTitle: 'Direct contact',
    shareTitle: 'Share this car',
    shareText: 'View%20this%20car%20at%20',
    route: 'Route',
    email: 'E-mail',
    tabs: {
      specs: 'Specifications',
      options: 'Options',
      desc: 'Description',
      warranty: 'Warranties',
      deliverOptions: 'Delivery packages',
    },
    deliverOptions: {
      description: 'Description',
      price: 'Price',
      inclTax: 'incl. VAT',
      contents: 'Contents',
    },
    warranty: {
      moreInfo: 'More information',
    },
  },
  filters: {
    title: 'Search used cars',
    modalTitle: 'Set up search filters',
    modalButton: 'View results',
    compare: 'Compare',
    filter: 'Filter',
    allBrands: 'All brands',
    allModels: 'All models',
    brand: 'Brand',
    model: 'Model',
    resetFilters: 'Clear filters',
    emptyState: {
      title: 'Nothing found',
      desc: "We couldn't find any vehicles that match the specified criteria. Adjust the filters or click the button to start over.",
      button: 'Reset all filters',
    },
    results: '{count} result | {count} results',
  },
  search: {
    inputTitle: 'Search term',
    inputPlaceholder: 'Search...',
    searchIn: 'Search in',
    searchInAll: 'All vehicles',
    searchInSelection: 'Vehicles from selection',
    submit: 'Search',
  },
  sort: {
    relevance: 'Relevance',
    alphabetically: 'Alphabetically',
    priceAsc: 'Price (low - high)',
    priceDesc: 'Price (high - low)',
    dateAddedDesc: 'Date added (new - old)',
    mileageAsc: 'Mileage (low - high)',
  },
  forms: {
    noTranslationAvailable:
      'Unfortunately, this part of the website cannot be served in your language. Please contact us if you need any help.',
    errors: {
      requiredFields: 'Please fill in all required fields',
      requiredFieldSingle: 'This field is required',
      acceptTerms: 'Please accept the terms and conditions',
      validEmail: 'Please fill in a valid e-mail address',
      noAddressFound: {
        text: 'The address could not be found. Have you entered the correct zip code and house number?',
        button: 'Enter manually',
      },
      somethingWentWrong: 'Something went wrong while sending the request. Try again later.',
    },
    fields: {
      salutation: 'Salutation',
      salutationMale: 'Mr.',
      salutationFemale: 'Mrs.',
      fullName: 'Full name',
      name: 'Name',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'E-mail address',
      phone: 'Phone number',
      address: 'Address',
      zip: 'Postal code',
      houseNumber: 'House number',
      houseNumberSupplement: 'Supplement',
      city: 'City',
      street: 'Street',
      birthDate: 'Date of birth',
      mileage: 'Mileage',
      comments: 'Comments',
      acceptTermsPre: 'I accept the',
      terms: 'terms and conditions',
      unknown: 'Unknown',
      submitRequest: 'Confirm request',
      yes: 'Yes',
      no: 'No',
      companyName: 'Company Name',
    },
    testRide: {
      title: 'Request a test drive',
      preferenceDate: 'Preferred test drive date',
      submit: 'Request test drive',
    },
    appointment: {
      title: 'Make an appointment',
      preferenceDate: 'Preferred date',
      preferenceTime: 'Preferred time',
      submit: 'Make an appointment',
    },
    tradeIn: {
      title: 'Calculate trade-in value',
    },
    privateLease: {
      title: 'Request a private lease',
      stepCalculator: 'Your private lease',
      stepPersonalDetails: 'Personal details',
      stepConfirm: 'Confirmation',
      leaseAmount: 'Lease amount',
      from: 'from',
      perMonth: 'per month',
      calculationDisclaimer: 'based on {mileage} km per year and a contract duration of {duration} months',
      calculatorTitle: 'Compile your private lease',
      calculatorDesc:
        'The lease amount depends on several factors. Request a quote here and discover your personal lease amount per month.',
      duration: 'Desired duration',
      months: 'months',
      mileagePerYear: 'Kilometers per year',
      damageFreeYears: 'Number of claim-free years',
      prepayment: 'Deposit',
      request: 'Request',
      toConfirmStep: 'To confirmation',
      confirmDesc: 'Check your details here and then confirm the application to submit it. We will contact you as soon as possible.',
      leaseDetails: 'Lease details',
      personalDetails: 'Personal details',
      edit: 'edit',
    },
    callMeBack: {
      title: 'Call me back',
      submit: 'Call me back',
    },
    finance: {
      title: 'Calculate financing',
      consumer: 'Private',
      business: 'Business',
      vehiclePrice: 'Vehicle purchase price',
      prepaymentTradeIn: 'Deposit / trade-in',
      creditSumLoanAmount: 'Credit amount / loan amount',
      durationInMonths: 'Duration in months',
      finalSum: 'Final sum',
      finalSumError: 'No final sum possible, the minimum amount to be financed is {amount}',
      monthlyFee: 'Monthly amount',
      calculationDisclaimer: 'The calculation is based on an {interestRate}% annual effective interest rate.',
      askOffer: 'Request a quote',
      stepCalculator: 'Your financing',
      stepPersonalDetails: 'Personal details',
      stepConfirm: 'Confirmation',
      financeDetails: 'Finance details',
      confirmDesc: 'Check your details here and then confirm the application to submit it. We will contact you as soon as possible.',
    },
    offer: {
      title: 'Request a quote',
      tradeInCar: 'Do you want to trade in a car?',
      yourLicense: 'Your license plate',
      submit: 'Request quote',
    },
    buy: {
      title: 'Buy this car online',
      stepPersonalDetails: 'Personal details',
      stepPaymentDelivery: 'Payment & Delivery',
      stepConfirm: 'Confirmation',
      personalDetailsDesc: 'Have you found your dream car? Great! Enter your details below to complete the order.',
      consumerOrBusiness: 'Is this a private or business order?',
      consumer: 'Private',
      business: 'Business',
      ownerQuestion: 'In whose name should the car be registered?',
      ownerSelf: 'My own name',
      ownerOther: 'Other name',
      ownerDetails: 'Ascription',
      driverLicenseCountry: 'Do you have a Dutch or foreign driving licence?',
      dutch: 'Dutch',
      foreign: 'Foreign',
      driverLicenseDisclaimer:
        "We need your driver's license number and date of birth for the ascription (registration) of the car. Driver's license number not within reach? No problem, we will contact you before delivery of the car.",
      driverLicenseNumber: "Driver's license number",
      toPaymentDetails: 'To payment method',
      paymentDetails: 'Payment method',
      paymentDetailsDesc: 'How would you like to pay, on delivery or in advance? The choice is yours.',
      paymentAtDelivery: 'Pay on delivery',
      paymentAtDeliveryDesc: 'You pay via internet banking when the car is delivered.',
      ideal: 'Payment request',
      idealDesc: 'You pay easily and securely with a link that you will receive by e-mail.',
      bankTransfer: 'Bank transfer',
      bankTransferDesc: 'You pay manually by bank transfer, you will receive the payment details by e-mail.',
      delivery: 'Delivery',
      deliveryDesc:
        'Choose here whether you want to have the car delivered to your home or collect it from us. Then indicate a desired delivery date, we will contact you to confirm it.',
      deliveryPackages: 'Deliver package',
      deliveryPackagesDesc: 'Please indicate below which deliver package you would like to include with your purchase.',
      home_delivery: 'Have it delivered at home',
      roadside_assistance: 'Roadside assistance',
      insurance: 'Insurance',
      extraOptions: 'Extra options',
      extraOptionsDesc: 'Add any additional options when purchasing your used car.',
      preferredDeliveryDate: 'Desired delivery date',
      toConfirm: 'To confirmation',
      confirmDesc: 'After you have checked your details, you can submit the application. We will contact you as soon as possible.',
      personalDetails: 'Personal details',
      edit: 'edit',
    },
  },
}

export default translations
